<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-3">
        <table class="table table-sm table-bordered">
          <colgroup>
            <col style="width: 50%">
            <col style="width: 50%">
          </colgroup>
          <tr>
            <th class="text-center font-weight-normal">
              Modificar
            </th>
            <td class="text-center">
              <b-form-checkbox
                id="checkbox-config"
                class="d-inline"
                v-model="itemData.enableConfig"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <p class="h6 font-weight-bolder">Fecha</p>
    <div class="border-section rounded p-1 mb-2">
      <div class="row">
        <div class="col-4">
          <b-form-group label="Año">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="years"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.year"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDateTime"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group label="Mes">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="months"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.month"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDateTime"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group label="Día">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="days"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.day"
              append-to-body
              :clearable="false"
              :disabled="disabledInputsDateTime"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
      </div>
    </div>
    <p class="h6 font-weight-bolder">Tiempo</p>
    <div class="border-section rounded p-1">
      <div class="row">
        <div class="col-4">
          <b-form-group label="Horas">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="hours"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.hours"
              append-to-body
              :clearable="false"
              :disabled="!itemData.enableConfig"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group label="Minutos">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="minutes"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.minutes"
              append-to-body
              :clearable="false"
              :disabled="!itemData.enableConfig"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group label="Segundos">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="seconds"
              class="w-100 datetime-select"
              :reduce="(val) => val.value"
              v-model="itemData.seconds"
              append-to-body
              :clearable="false"
              :disabled="!itemData.enableConfig"
              :calculate-position="withPopper"
            />
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import popperHelper from "@/libs/popper-helper";
import vSelect from "vue-select";

export default {
  props:{
    itemData:{
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    vSelect
  },
  setup (props) {
    //DATA
    const hours = Array.from({ length: 24 }, (_, index) => ({
      value: index,
      label: String(index).padStart(2, '0')
    }));

    const minutes = Array.from({ length: 60 }, (_, index) => ({
      value: index,
      label: String(index).padStart(2, '0')
    }));

    const months = [
      { value: 1, label: 'Enero' },
      { value: 2, label: 'Febrero' },
      { value: 3, label: 'Marzo' },
      { value: 4, label: 'Abril' },
      { value: 5, label: 'Mayo' },
      { value: 6, label: 'Junio' },
      { value: 7, label: 'Julio' },
      { value: 8, label: 'Agosto' },
      { value: 9, label: 'Septiembre' },
      { value: 10, label: 'Octubre' },
      { value: 11, label: 'Noviembre' },
      { value: 12, label: 'Diciembre' }
    ];

    const seconds = Array.from({ length: 60 }, (_, index) => ({
      value: index,
      label: String(index).padStart(2, '0')
    }));


    const years = [
      { label: '2000', value: 2000 },
      { label: '2001', value: 2001 },
      { label: '2002', value: 2002 },
      { label: '2003', value: 2003 },
      { label: '2004', value: 2004 },
      { label: '2005', value: 2005 },
      { label: '2006', value: 2006 },
      { label: '2007', value: 2007 },
      { label: '2008', value: 2008 },
      { label: '2009', value: 2009 },
      { label: '2010', value: 2010 },
      { label: '2011', value: 2011 },
      { label: '2012', value: 2012 },
      { label: '2013', value: 2013 },
      { label: '2014', value: 2014 },
      { label: '2015', value: 2015 },
      { label: '2016', value: 2016 },
      { label: '2017', value: 2017 },
      { label: '2018', value: 2018 },
      { label: '2019', value: 2019 },
      { label: '2020', value: 2020 },
      { label: '2021', value: 2021 },
      { label: '2022', value: 2022 },
      { label: '2023', value: 2023 },
      { label: '2024', value: 2024 },
      { label: '2025', value: 2025 },
      { label: '2026', value: 2026 },
      { label: '2027', value: 2027 }
    ];

    //COMPUTED
    const days = computed(() => {
      if (!props.itemData.year || !props.itemData.month) {
        return [];
      }

      const totalDays = new Date(
        props.itemData.year,
        props.itemData.month,
        0
      ).getDate();

      return Array.from({ length: totalDays }, (_, index) => ({
        value: index + 1,
        label: String(index + 1)
      }));
    });

    const disabledInputsDateTime = computed(() => (!props.itemData.enableConfig || props.loading));

    return {
      hours,
      minutes,
      months,
      seconds,
      years,
      withPopper: popperHelper.withPopper,

      days,
      disabledInputsDateTime
    }
  }
}
</script>

<style lang="scss" scoped>
.border-section {
  border: 1px solid rgba(0, 0, 0, .125);
}

table.table tr th {
  background-color: #f8f9fa;
}
</style>
